/** Index query builder. Not `pick`, which drops falsy values: `stale` is tri-state and `false` is a
 *  real filter. Emptiness, not falsiness — `null`, `undefined`, `''` dropped; `false`, `0` kept. */
type QueryPrimitive = string | number | boolean

export const compactQuery = (
  params: Record<string, QueryPrimitive | null | undefined>,
): Record<string, QueryPrimitive> => {
  const result: Record<string, QueryPrimitive> = {}

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return
    result[key] = value
  })

  return result
}
